import { defineStore } from 'pinia'
import { ref, Ref } from 'vue'

import { useLocalization } from '@/shared/composables/localization'
import { getAppURL } from '@/shared/utils/electron'
import { useFetchApi } from '@/shared/utils/fetch'

import { Equipment } from './'

export const useEquipmentStore = defineStore('equipment', () => {
  const isLoading = ref(false)
  const equipments: Ref<Equipment[]> = ref([])

  const { get } = useFetchApi()
  const { t } = useLocalization()

  const getEquipmentByMac = (mac: Equipment['mac']) => {
    return equipments.value.find(i => i.mac === mac)
  }

  const fetchAll = async () => {
    try {
      isLoading.value = true
      const { data = [] } = await get<Equipment[]>(getAppURL({ pathName: '/api/equipment' }))
      equipments.value = data
      return data
    } catch (err) {
      throw new Error(t('common.failedToLoadList', { err }))
    } finally {
      isLoading.value = false
    }
  }

  return {
    fetchAll,
    getEquipmentByMac,
    equipments,
  }
})
